import { render, staticRenderFns } from "./WaitTickets.vue?vue&type=template&id=01085a0f&scoped=true&"
import script from "./WaitTickets.vue?vue&type=script&lang=js&"
export * from "./WaitTickets.vue?vue&type=script&lang=js&"
import style0 from "./WaitTickets.vue?vue&type=style&index=0&id=01085a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01085a0f",
  null
  
)

export default component.exports